export const staticLinks = {
  howItWorks: "https://www.mightier.com/",
  faqs: "https://www.mightier.com/greenshield-faq/",
  contactPage: "https://www.mightier.com/contact-us/",
  createSupportTicketPage: "https://support.mightier.com/hc/en-us/requests/new",
};
